import { inject, Signal } from '@angular/core';
import { Router } from '@angular/router';

import {
  ChurnFlowAnalyticsBaseService,
  ChurnFlowDataBaseService,
  ChurnFlowNavigationBaseService,
} from '@core/churn-flow-logic';
import { ChurnFlowSupportedLocale, ChurnReason } from '@core/churn-flow-types';
import { injectTranslate, LOCALE } from '@core/i18n-legacy';
import { IntercomService } from '@core/intercom-integration-legacy';
import { NotificationsController, WindowRef } from '@core/user-interface-legacy';

export abstract class ChurnFlowReasonBaseComponent {
  protected readonly t = injectTranslate();
  protected readonly router = inject(Router);
  protected readonly notificationsController = inject(NotificationsController);
  protected readonly churnFlowDataService = inject(ChurnFlowDataBaseService);
  protected readonly intercom = inject(IntercomService);
  protected readonly window = inject(WindowRef);
  protected readonly locale = inject(LOCALE);
  protected readonly analytics = inject(ChurnFlowAnalyticsBaseService);
  protected readonly navigationService = inject(ChurnFlowNavigationBaseService);

  protected abstract reason: ChurnReason;

  public abstract readonly infoboxMessage: Signal<string | undefined>;
  // For v1, the navigation applies to TAC/One Settings context.
  // For v2 (legacy plan implementation), the navigation will be made more generic to also be able to handle Recruitee context. Legacy plans are being phased out anyway.

  protected stayWithTellent(): void {
    this.analytics.trackStayWithTellent({ reason: this.reason });
    this.navigationService.stayWithTellent();
  }

  protected stillWantToCancel(): void {
    this.analytics.trackStepThreeContinue({ reason: this.reason });
    this.router.navigate([{ outlets: { dialog: ['churn', 'subscription-loss'] } }]);
  }

  protected openIntercom(message: string = ''): void {
    this.intercom.startNewMessage(message);
  }

  protected getTrainingScheduleLink(): string {
    switch (this.locale) {
      case ChurnFlowSupportedLocale.Dutch:
        return 'https://tellent.registration.goldcast.io/series/d1368382-0ccf-4eff-b485-2244da037c60';
      case ChurnFlowSupportedLocale.German:
        return 'https://admin.goldcast.io/webinar/4eccf6e1-51a4-411f-bebc-2f348c5ccef6/details';
      case ChurnFlowSupportedLocale.RestOfWorld:
        return 'https://tellent.registration.goldcast.io/repeating-event/a060fdb2-1648-457d-a9e8-fade2eb79afe';
      case ChurnFlowSupportedLocale.French:
        return 'https://us02web.zoom.us/meeting/register/4jWrttdrQkSthPktSxak_w#/registration';
      default:
        return 'https://tellent.registration.goldcast.io/repeating-event/a060fdb2-1648-457d-a9e8-fade2eb79afe';
    }
  }
}
